import { Component, OnInit, OnChanges, Input, SimpleChanges, Output, EventEmitter, CUSTOM_ELEMENTS_SCHEMA, ViewChild, ElementRef } from '@angular/core';
import { TeamQueueEnqueue } from '../../../../models/team/team-queue-enqueue.model';
import { MatSliderModule } from '@angular/material/slider';
import { NumericInputDirective } from '../../../../directives/numeric-input.directive';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormsModule } from '@angular/forms';
import { AccountService } from '../../../../services/account.service';

@Component({
  selector: 'app-manage-queue-enqueue',
  templateUrl: './manage-queue-enqueue.component.html',
  styleUrls: ['./manage-queue-enqueue.component.css'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    MatButtonModule,
    MatFormFieldModule,
    MatSliderModule,
    FormsModule,
    NumericInputDirective,
    MatInputModule
  ]
})
export class ManageQueueEnqueueComponent implements OnInit, OnChanges {
  @Input() model: TeamQueueEnqueue;
  @Input() isUpdating: boolean = false;
  @Output() modelChange = new EventEmitter<TeamQueueEnqueue>();
  @Output() enqueue = new EventEmitter<number>();
  @ViewChild('sliderInput') numberInput!: ElementRef<HTMLInputElement>;

  sliderMax: number;
  sliderValue: number;
  activeProjectTitle: string
  constructor(
    private accountService: AccountService
  ) {
    if (this.model) {
      this.sliderMax = this.model.maxAbstracts;
      this.sliderValue = this.model.selectedAbstracts
    }
    this.activeProjectTitle = this.accountService.GetActiveProject().projectTitle;
  }

  //isUpdating: boolean = false;

  ngOnInit() {
    // console.log(this.model)
  }

  ngOnChanges(changes: SimpleChanges) {


    for (let propName in changes){
      if (propName == "model") {
      
        this.model = changes[propName].currentValue;
  
        this.sliderMax = this.model.maxAbstracts;
        this.sliderValue = this.model.selectedAbstracts;

      }
      else if (propName == "isUpdating")
        this.isUpdating = changes[propName].currentValue;
      }
  }

  sliderChange(event: number) {
    console.log(event);
    this.sliderValue = event;
    this.model.selectedAbstracts = event;
    this.updateModel(this.model);
  }

  numericInputChange(event: any) {
    console.log(event);
    let val = parseInt(event.target.value);
    this.model.selectedAbstracts = this.sliderValue = val < 0 ? 0 : (val > this.model.maxAbstracts ? this.model.maxAbstracts : val);
    this.updateModel(this.model);
  }

  updateModel(value: TeamQueueEnqueue) {
    this.model = value;
    this.modelChange.emit(value);
  }

  addQueue() {
    if (this.model.selectedAbstracts > 0){
      this.enqueue.emit(this.model.selectedAbstracts);
      this.model.maxAbstracts = this.model.maxAbstracts - this.model.selectedAbstracts;
      this.sliderValue = 0;
      this.model.selectedAbstracts = 0;
      this.updateModel(this.model);
    }
  }
}
